import { render, staticRenderFns } from "./orderInfo.vue?vue&type=template&id=0820e8ab&scoped=true"
import script from "./orderInfo.vue?vue&type=script&lang=js"
export * from "./orderInfo.vue?vue&type=script&lang=js"
import style0 from "./orderInfo.vue?vue&type=style&index=0&id=0820e8ab&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820e8ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0820e8ab')) {
      api.createRecord('0820e8ab', component.options)
    } else {
      api.reload('0820e8ab', component.options)
    }
    module.hot.accept("./orderInfo.vue?vue&type=template&id=0820e8ab&scoped=true", function () {
      api.rerender('0820e8ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/customerManage/orderInfo.vue"
export default component.exports